export default __webpack_public_path__ + "static/media/up_arrow.3dd2c1b7.svg";